export const environment = {
  production: false,
  apiUrl: 'https://api.visuwell-dev.apzumi.dev/ai-chat',
};
